import "../ChartLegend.css";

import { TruncatedText } from "../../../general/TruncatedText";
import { ChartVariant } from "../../utils";

interface ChartLegendLabelProps {
  text: string;
  /** The chart's resolved brand, which beats the provider. */
  variant?: ChartVariant;
}

/**
 * A legend name, cut to one line with the full name on hover — see TruncatedText. Not focusable
 * itself: the row it sits in is a button, which reveals the tooltip on focus.
 */
export const ChartLegendLabel = ({ text, variant }: ChartLegendLabelProps): JSX.Element => (
  <TruncatedText text={text} className="ChartLegendLabel" variant={variant} isFocusable={false} />
);
